// デバイス判定やユーティリティを提供するクラスをインポート
import { DeviceChecker } from './deviceChecker';

// DeviceChecker クラスをインスタンス化
const deviceChecker = new DeviceChecker();

/**
 * ScrollItem クラス
 * 指定した要素（例: .step_h, .step_flow）の幅を
 * 中身のスクロール幅（scrollWidth）に合わせて調整するクラス
 */
class ScrollItem {
    constructor() {
        // コンストラクタで初期化処理を実行
        this.init();
    }

    /**
     * 初期化処理
     * window の load / resize イベント発火時に setWidth を実行する
     * - deviceChecker._debounce を利用して処理を間引き（200ms間隔）
     */
    init() {
        $(window).on(
            'load resize',
            deviceChecker._debounce(() => {
                // 指定クラスを持つ要素の幅を調整
                this.setWidth('.step_h');
                this.setWidth('.step_flow');
            }, 200)
        );
    }

    /**
     * 指定したセレクタの要素に対して幅を調整する
     * @param {string} selector - 対象要素のセレクタ
     */
    setWidth(selector) {
        const elements = $(selector); // 該当する要素を取得

        elements.each(function () {
            // いったん width を auto に戻す（再計算のため）
            $(this).css('width', 'auto');

            // 要素の scrollWidth（内部コンテンツ全体の幅）を取得して width に設定
            // → これにより、要素の内容に応じた横スクロール幅が適用される
            $(this).css('width', `${this.scrollWidth}px`);
        });
    }
}

// ScrollItem クラスをエクスポート
export default ScrollItem;
